var map = {
	"./icon_gear_item_axe_dark.png": 8529,
	"./icon_gear_item_axe_fire.png": 4377,
	"./icon_gear_item_axe_holy.png": 2849,
	"./icon_gear_item_axe_ice.png": 3229,
	"./icon_gear_item_axe_lightning.png": 8889,
	"./icon_gear_item_axe_royal.png": 1243,
	"./icon_gear_item_bow_dark.png": 2969,
	"./icon_gear_item_bow_fire.png": 7148,
	"./icon_gear_item_bow_holy.png": 9281,
	"./icon_gear_item_bow_ice.png": 2653,
	"./icon_gear_item_bow_lightning.png": 8908,
	"./icon_gear_item_bow_royal.png": 9068,
	"./icon_gear_item_staff_dark.png": 7025,
	"./icon_gear_item_staff_fire.png": 6688,
	"./icon_gear_item_staff_holy.png": 8119,
	"./icon_gear_item_staff_ice.png": 9776,
	"./icon_gear_item_staff_lightning.png": 6115,
	"./icon_gear_item_staff_royal.png": 7343,
	"./icon_gear_item_sword_dark.png": 7001,
	"./icon_gear_item_sword_fire.png": 4406,
	"./icon_gear_item_sword_holy.png": 3472,
	"./icon_gear_item_sword_ice.png": 4450,
	"./icon_gear_item_sword_lightning.png": 3051,
	"./icon_gear_item_sword_royal.png": 5388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3950;